module.exports = __webpack_public_path__ + "img/add-slots.840d065c.svg";